import axios from "./axios";

export const createEvent = async (body: any): Promise<any> => {
  try {
    const response = await axios.post<any>(`/api/events`, body);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const getEventDetails = async (eventId?: string): Promise<any> => {
  try {
    if (!eventId) return;
    const response = await axios.get<any>(`/api/events/${eventId}`);
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const getCancelReasons = async (): Promise<any> => {
  try {
    const response = await axios.get<any>(
      `/api/events/lookups/cancelation-reasons`
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};

export const getEventsListing = async (
  offset: number,
  country?: number,
  city?: number,
  status?: string | null,
  type?: string | null,
  minDate?: string,
  maxDate?: string,
  isMyEvent?: boolean,
  limit?: number
) => {
  try {
    let queryParams = `?limit=${limit || 5}&offset=${offset * 5}`;
    if (status) queryParams += `&status=${status}`;
    if (type) queryParams += `&type=${type}`;
    if (minDate) queryParams += `&dateMin=${minDate}`;
    if (maxDate) queryParams += `&dateMax=${maxDate}`;
    if (country) queryParams += `&countryId=${country}`;
    if (city) queryParams += `&cityId=${city}`;
    if (isMyEvent) queryParams += `&owner=ME`;

    const response = await axios.get(`/search/events${queryParams}`, {
      headers: { os: "iOS" },
    });
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to fetch events");
  }
};

export const cancelEvent = async (eventId: any, body: any) => {
  try {
    const response = await axios.delete(`/api/events/${eventId}`, {
      data: body,
    });
    return response.data;
  } catch (err: any) {
    throw new Error(`Failed to delete event: ${err.message}`);
  }
};

export const getEventJoinRequests = async (
  eventId: string | null,
  page: number
): Promise<any> => {
  try {
    if (!eventId || !page) return;
    const response = await axios.get<any>(
      `/api/events/${eventId}/requests?page=${page}&limit=5&maxCount=5`
    );
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to get event join requests");
  }
};

export const getEventJoiningPlayers = async (
  eventId?: string
): Promise<any> => {
  try {
    if (!eventId) return;
    const response = await axios.get<any>(`/api/events/${eventId}/players`);
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to get event joining players");
  }
};

export const removeJoiningPlayersFromEvent = async (
  eventId?: string,
  playerId?: string
): Promise<any> => {
  try {
    if (!eventId || !playerId) return;
    const response = await axios.delete<any>(
      `/api/events/${eventId}/players/${playerId}`
    );
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to get event joining players");
  }
};

export const removeRequestingPlayersFromEvent = async (
  eventId?: string,
  playerId?: string
): Promise<any> => {
  try {
    if (!eventId || !playerId) return;
    const response = await axios.delete<any>(
      `/api/events/${eventId}/requests/${playerId}`
    );
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to get event joining players");
  }
};

export const acceptRequestingPlayersFromEvent = async (
  eventId?: string,
  requestId?: string
): Promise<any> => {
  try {
    if (!eventId || !requestId) return;
    const response = await axios.patch<any>(
      `/api/events/${eventId}/requests/${requestId}`,
      { action: "ACCEPT" }
    );
    return response.data.data;
  } catch (err) {
    throw new Error(err + " Failed to get event joining players");
  }
};

export const invitePlayersToEvent = async (
  eventId: string | null,
  body: any
): Promise<any> => {
  try {
    if (!eventId) return;
    const response = await axios.post<any>(
      `/api/events/${eventId}/invites`,
      body
    );
    return response.data;
  } catch (err) {
    throw new Error(err + " Failed to create event");
  }
};
